import {
  Control,
  Controller,
  FieldValues,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue
} from "react-hook-form";

import Input from "components/Input";
import Select from "components/Select";
import Toggle from "components/Toggle";
import { PAYMENT_SPEED_LIST, PORTION_PERCENT_LIST } from "constants/haulpay-broker";
import styles from "./style.module.scss";
import { IPaymentSpeed } from "models/HaulPay";

interface IProps {
  index: number;
  name?: string;
  control: Control<FieldValues, any>;
  register: UseFormRegister<FieldValues>;
  getValues: UseFormGetValues<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  isFactoringPaymentTerm?: boolean;
  paymentTerms: IPaymentSpeed[];
}

export default function DefaultPaymentSpeedSettingItem({
  index,
  name = "terms",
  control,
  register,
  getValues,
  setValue,
  isFactoringPaymentTerm,
  paymentTerms
}: Readonly<IProps>) {
  return (
    <ul className={styles.itemContainer}>
      {isFactoringPaymentTerm ? (
        <li className="my-auto desktop:mr-10"></li>
      ) : (
        <li className="my-auto desktop:mr-10">
          <Toggle
            name={`${name}[${index}].enable_payment_profile`}
            className="pr-2 -mx-4"
            register={register}
          />
        </li>
      )}
      <li className="desktop:mr-10">
        <Controller
          name={`${name}[${index}].payout_days`}
          control={control}
          render={({ field: { value, onChange } }) => (
            <Select
              options={PAYMENT_SPEED_LIST}
              value={PAYMENT_SPEED_LIST.find((item) => item.id === value)}
              onChange={(item) => {
                onChange(item.id);
                setValue(
                  `${name}[${index}].discount_rate`,
                  paymentTerms.find((term) => term.payout_days === item.id)?.discount_rate + "%"
                );
              }}
              btnClass="!py-1.5 !pl-1.5 !pr-4 desktop:!p-2.5"
              className={styles.select}
              arrowClass="!right-0"
              dropdownClass="!p-2"
              disabled={!isFactoringPaymentTerm}
            />
          )}
        />
      </li>
      <li className="desktop:mr-10">
        <Input
          name={`${name}[${index}].discount_rate`}
          register={register}
          inputClass="!border-icon !rounded-lg !p-1.5 desktop:!p-2.5 h-7 desktop:h-10 text-xs desktop:text-sm"
          disabled
        />
      </li>
      <li className="desktop:mr-10">
        <Controller
          name={`${name}[${index}].factoring_fee_split_rate`}
          control={control}
          render={({ field: { value, onChange } }) => (
            <Select
              options={PORTION_PERCENT_LIST}
              value={PORTION_PERCENT_LIST.find((item) => item.id === value)}
              onChange={(item) => {
                onChange(item.id);
                const discount_rate = parseFloat(getValues(`${name}[${index}].discount_rate`));
                const new_rate = (+discount_rate * (100 - Number(item.value))) / 100 + "%";
                setValue(`${name}[${index}].carrier_rate`, new_rate);
              }}
              btnClass="!py-1.5 !pl-1.5 !pr-4 desktop:!p-2.5"
              className="w-full text-xxs desktop:text-sm"
              arrowClass="!right-0"
              dropdownClass="!p-2"
              disabled={isFactoringPaymentTerm}
            />
          )}
        />
      </li>
      <li className="desktop:mr-10">
        <Input
          disabled
          name={`${name}[${index}].carrier_rate`}
          register={register}
          inputClass="!border-icon !rounded-lg !p-1.5 desktop:!p-2.5 h-7 desktop:h-10 text-xs desktop:text-sm"
        />
      </li>
    </ul>
  );
}
